module.exports = __webpack_public_path__ + "img/recharge-tips.7394a372.png";